import React, {Suspense, lazy} from 'react';
import {createBrowserRouter, Navigate, useParams} from "react-router-dom";
import ConnectAdwordsAccount from "./components/agency/link_acocunts/ConnectAdwordsAccount";
import EditBusinessUnitPage from "./components/business_units/global_info/BusinessUnitGlobalInfo";
import AgencyClients from "./components/agency/AgencyClients";
import {AgencyPortalUsage} from "./components/agency/portal_usage/AgencyPortalUsage";
import {AgencyIABooster} from "./components/agency/ia_booster/AgencyIABooster";
import {AgencyPromptsPage} from "./components/agency/prompts/AgencyPromptsPage";
import {AlertsCenterPage} from "./components/alerts_center/AlertsCenterPage";
import {AlertsConfigurationRoute} from "./components/alerts_center/AlertsConfigurationRoute";
import {LearnPage} from "./components/learn/LearnPage";
import AgencyTeam from "./components/agency/AgencyTeam";
import ClientConfiguration from "./components/client/ClientConfiguration";
import ClientActivityLog from "./components/client/ClientActivityLog";
import ClientMemoryTab from "./components/client/ClientMemoryTab";
import ClientBoosterPage from "./components/client/ia_booster/flow/ClientBoosterPage";
import ClientMediaPlanTab from "./components/client/media_plan/ClientMediaPlanTab";
import ClientProfile from "./components/client/ClientProfile";
import ClientIAAssistant from "./components/client/ClientIAAssistant";
import {ClientIATab} from "./components/client/ClientIATab";
import ClientReports from "./components/client/ClientReports";
import { PortalReportsLanding } from "./components/portal/reports/PortalReportsLanding";
import ClientAgent from "./components/client/ClientAgent";
import {LoginPage, SignUpPage} from "./components/login/LoginPage";
import AgencyRegister from "./components/agency/AgencyRegister";
import {OnboardingGate} from "./components/onboarding/OnboardingGate";
import {OnboardingScreen} from "./components/onboarding/OnboardingScreen";
import {StepPlatforms} from "./components/onboarding/steps/StepPlatforms";
import {StepClients} from "./components/onboarding/steps/StepClients";
import {StepBudgets} from "./components/onboarding/steps/StepBudgets";
import {ApplyInterstitial} from "./components/onboarding/steps/ApplyInterstitial";
import {StepDone} from "./components/onboarding/steps/StepDone";
import {StepConnectAI} from "./components/onboarding/steps/StepConnectAI";
import {StepSavedProgress} from "./components/onboarding/steps/StepSavedProgress";
import {LineWizardEntry, LineWizardScreen} from "./components/line_wizard/LineWizardScreen";
import {LineWizardStep} from "./components/line_wizard/LineWizardStep";
import AcceptInvitation from "./components/login/AcceptInvitation";
import {PageNotFound, RouterErrorPage} from "./404";
import BusinessUnitBudgetHistory from "./components/business_units/BusinessUnitBudgetHistory"
import BusinessUnitAlertsConfiguration from "./components/business_units/BusinessUnitAlertsConfiguration";
import {AgencyOrPortalPrivateRoute, AgencyPrivateRoute, CRMPrivateRoute, PortalPrivateRoute} from "./utils/PrivateRoute";
import {KnewsPage} from "./components/knews/KnewsPage";
import {LoginCrm} from "./components/crm/login/LoginCrm";
import LeadsPage from "./components/crm/leads/leads_list/LeadsPage";
import LeadDetail from "./components/crm/leads/lead_detail/LeadDetail";
import ConfigPage from "./components/crm/configuration/ConfigPage";
import ClientCRMUsers from "./components/client/ClientCRMUsers";
import ClientDashboUsers from "./components/client/ClientDashboUsers";
import UserConfiguration from "./components/user/UserConfiguration";
import BusinessUnitAccounts from "./components/business_units/accounts/BusinessUnitAccounts";
import ClientMonitoringRoute from "./components/client/ClientMonitoringRoute";
import ClientBudgetHistory from "./components/client/ClientBudgetHistory";
import ClientControlCentral from "./components/client/ClientControlCentral";
import ClientDefaultRoute from "./components/client/ClientDefaultRoute";
import ClientLines from "./components/client/ClientLines";
import ClientAlerts from "./components/client/ClientAlerts";
import ClientEconomia from "./components/client/ClientEconomia";
import {EscalafyCallback} from "./components/client/economia/EscalafyCallback";
import ClientConnections from "./components/client/ClientConnections";
import {AgencyAdAccountsAndStoresWrapper} from "./components/agency/AgencyAdAccountsAndStoresWrapper";
import AgencySubscription from "./components/agency/AgencySubscription";
import UserAlerts from "./components/user/UserAlerts";
import UserSecurity from "./components/user/UserSecurity";
import UserModuleMarketing from "./components/user/UserModuleMarketing";
import UserModuleManageAccounts from "./components/user/UserModuleManageAccounts";
import AdAccountList from "./components/manage_accounts/AdAccountList";
import {Default} from "./components/Default";
import {DashboardWrapper} from "./components/dashboard/DashboardWrapper";
import {Report} from "./components/reports/Report";
import {AgencyProfile} from "./components/agency/AgencyProfile";
import ClientAppContent from "./components/client/ClientAppContent";
import {FreeTrialEndedPage} from "./components/subscription_not_active/FreeTrialEnded";
import {SubscriptionEndedPage} from "./components/subscription_not_active/SubscriptionEnded";
import UserProfile from "./components/user/UserProfile";
import AgencyConnectionsConfiguration from "./components/agency/AgencyConnectionsConfiguration";
import AgencyFlexIndicatorsConfiguration from "./components/agency/AgencyFlexIndicatorsConfiguration";
import CustomMetricsPage from "./components/agency/CustomMetricsPage";
import {CustomMetricsRouteGuard} from "./components/agency/CustomMetricsRouteGuard";
import UserClients from "./components/user/UserClients";
import ConnectTiktok from "./components/agency/link_acocunts/ConnectTiktok";
import ConnectLinkedin from "./components/agency/link_acocunts/ConnectLinkedin";
import ConnectGA4Account from "./components/agency/link_acocunts/ConnectGA4Account";
import ConnectGSCAccount from "./components/agency/link_acocunts/ConnectGSCAccount";
import ConnectDV360Account from "./components/agency/link_acocunts/ConnectDV360Account";
import ConnectMercadoAdsAccount from "./components/agency/link_acocunts/ConnectMercadoAdsAccount";
import {Spinner} from "./components/Spinner";
import ConnectShopify from "./components/agency/link_acocunts/ConnectShopify";
import ShopifyMerchantSuccess from "./components/shopify_merchant/ShopifyMerchantSuccess";
import ShopifyMerchantError from "./components/shopify_merchant/ShopifyMerchantError";
import ConnectTiendaNube from "./components/agency/link_acocunts/ConnectTiendaNube";
import SyncConfigurations from "./components/agency/SyncConfigurations";
import AgencyConnectionsExport from "./components/agency/AgencyConnectionsExport";
import App from "./App";
import {DataExplorerPage} from "./components/data_explorer/DataExplorerPage";
import {InformesPage} from "./components/informes/InformesPage";
import {AgentArea} from "./components/agent/AgentArea";
import {ReportViewer} from "./components/public_reports/ReportViewer";
import {AllReportsPage} from "./components/reports/AllReportsPage";
import {TemplateLibraryPage} from "./components/reports/templates/TemplateLibraryPage";
import {TemplateEditorPage} from "./components/reports/templates/TemplateEditorPage";
import {DashboMCPPage} from "./components/dashbo_mcp/DashboMCPPage";
import {DemoReportPage} from "./components/dashbo_mcp/DemoReportPage";
import {AuthFromMCP} from "./components/login/AuthFromMCP";
import {PortalHome} from "./components/portal/PortalHome";
import {PortalDashboMCP} from "./components/portal/PortalDashboMCP";
import {PortalConnections} from "./components/portal/PortalConnections";
import {PortalMemory} from "./components/portal/PortalMemory";
import {ClientPortalPreview} from "./components/client/preview/ClientPortalPreview";
import {ClientPortalTabPage} from "./components/client/ClientPortalTabPage";

// Redirect helper que preserva el :id del cliente hacia la ruta real de conexiones
// (el path real usa el typo legacy "conections" con una sola "n").
function RedirectToClientConnections() {
    const {id} = useParams();
    return <Navigate to={`/client/${id}/conections`} replace/>;
}

// Redirect del preview viejo /dashbo-connect → /dashbo-mcp preservando el :id (rebrand Connect→MCP).
function RedirectToClientPreviewMCP() {
    const {id} = useParams();
    return <Navigate to={`/client/${id}/preview/dashbo-mcp`} replace/>;
}

// Array de rutas hijas (planas) bajo la layout route <App/>. Se exporta aparte del router
// para que el test guardián (src/tests/routeScreens.test.js) verifique que toda ruta-hoja
// tenga handle.screen válido o esté explícitamente excluida.
export const routeChildren = [
            {
                path: "/login",
                element: <LoginPage/>
            },
            {
                path: "/free-trial-ended",
                element: <FreeTrialEndedPage/>,
                handle: {screen: 'free_trial_ended'}
            },
            {
                path: "/subscription-ended",
                element: <SubscriptionEndedPage/>
            },
            {
                path: "/signup",
                element: <SignUpPage/>
            },
            {
                path: "/accept-invitation/:hash",
                element: <AcceptInvitation/>
            },
            {
                path: "/auth/from-mcp",
                element: <AuthFromMCP/>
            },
            {
                path: "/",
                element: <AgencyPrivateRoute><Default/></AgencyPrivateRoute>,
                handle: {screen: 'dashboard'}
            },
            {
                path: "/novedades",
                element: <AgencyPrivateRoute><KnewsPage/></AgencyPrivateRoute>,
                handle: {screen: 'novedades'}
            },
            {
                path: "/agent/chat/:sessionId?",
                element: <AgencyPrivateRoute><AgentArea/></AgencyPrivateRoute>,
                handle: {screen: 'agent_chat'}
            },
            {
                path: "/marketing",
                element: <AgencyPrivateRoute><DashboardWrapper/></AgencyPrivateRoute>,
                handle: {screen: 'marketing'}
            },
            {
                path: "/data-explorer",
                element: <AgencyPrivateRoute><DataExplorerPage/></AgencyPrivateRoute>,
                handle: {screen: 'data_explorer'}
            },
            {
                // Informes (sobre la app de bloques). Convive con /data-explorer: la modalidad de
                // la agencia decide cuál se ofrece en el menú; ambas rutas siguen vivas. En la 2.1,
                // `?client_id=` y `/informes/:informeId` redirigen a la ficha del cliente.
                path: "/informes",
                element: <AgencyPrivateRoute><InformesPage/></AgencyPrivateRoute>,
                handle: {screen: 'informes'}
            },
            {
                path: "/informes/:informeId",
                element: <AgencyPrivateRoute><InformesPage/></AgencyPrivateRoute>,
                handle: {screen: 'informe_editor'}
            },
            {
                path: "/insights",
                element: <AgencyPrivateRoute><Report/></AgencyPrivateRoute>,
                handle: {screen: 'insights'}
            },
            {
                path: "/reports/templates/:id",
                element: <AgencyPrivateRoute><TemplateEditorPage/></AgencyPrivateRoute>,
                handle: {screen: 'reports_template_editor'}
            },
            {
                path: "/reports/templates",
                element: <AgencyPrivateRoute><TemplateLibraryPage/></AgencyPrivateRoute>,
                handle: {screen: 'reports_templates'}
            },
            {
                path: "/reports",
                element: <AgencyPrivateRoute><AllReportsPage/></AgencyPrivateRoute>,
                handle: {screen: 'reports'}
            },
            {
                path: "/dashbo-connect",
                element: <Navigate to="/dashbo-mcp" replace/>
            },
            {
                path: "/dashbo-connect/demo-report",
                element: <Navigate to="/dashbo-mcp/demo-report" replace/>
            },
            {
                path: "/dashbo-mcp",
                element: <AgencyPrivateRoute><DashboMCPPage/></AgencyPrivateRoute>,
                handle: {screen: 'dashbo_mcp'}
            },
            {
                path: "/dashbo-mcp/demo-report",
                element: <AgencyPrivateRoute><DemoReportPage/></AgencyPrivateRoute>,
                handle: {screen: 'dashbo_mcp_demo_report'}
            },
            // Con el Centro de Alertas (2.1 + flag de la agencia) lleva a «Mis reglas»; si no, la de siempre.
            {
                path: "/agency/alerts-configuration",
                element: <AgencyPrivateRoute><AlertsConfigurationRoute/></AgencyPrivateRoute>,
                handle: {screen: 'agency_alerts'}
            },
            {
                path: "/agency-register",
                element: <AgencyPrivateRoute><AgencyRegister/></AgencyPrivateRoute>,
                handle: {screen: 'agency_register'}
            },
            // El túnel de alta (UX 2.1). Cada paso es su propia ruta: la autorización de las
            // plataformas navega fuera de la aplicación y tiene que poder volver a un lugar concreto,
            // y así recargar en medio del recorrido re-entra donde el usuario estaba.
            {
                path: "/onboarding",
                element: <AgencyPrivateRoute><OnboardingGate/></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_gate'}
            },
            {
                path: "/onboarding/plataformas",
                element: <AgencyPrivateRoute><OnboardingScreen step="platforms"><StepPlatforms/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_platforms'}
            },
            {
                path: "/onboarding/clientes",
                element: <AgencyPrivateRoute><OnboardingScreen step="clients"><StepClients/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_clients'}
            },
            {
                path: "/onboarding/presupuestos",
                element: <AgencyPrivateRoute><OnboardingScreen step="budgets"><StepBudgets/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_budgets'}
            },
            {
                path: "/onboarding/creando",
                element: <AgencyPrivateRoute><OnboardingScreen step="budgets"><ApplyInterstitial/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_applying'}
            },
            {
                path: "/onboarding/listo",
                element: <AgencyPrivateRoute><OnboardingScreen><StepDone/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_done'}
            },
            {
                path: "/onboarding/ia",
                element: <AgencyPrivateRoute><OnboardingScreen><StepConnectAI/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_ia'}
            },
            // Sólo en el celular: «Guardamos tu avance», la salida del paso de plataformas (UD-23 de `/ux`).
            {
                path: "/onboarding/seguir-en-la-computadora",
                element: <AgencyPrivateRoute><OnboardingScreen><StepSavedProgress/></OnboardingScreen></AgencyPrivateRoute>,
                handle: {screen: 'onboarding_mobile_continue'}
            },
            // El wizard «Nueva línea de control» de la UX 2.1 (card CvdQbnl2). `/lines/new?client=<id>`
            // arranca un borrador nuevo; cada paso es su propia ruta para poder volver del OAuth.
            {
                path: "/lines/new",
                element: <AgencyPrivateRoute><LineWizardEntry/></AgencyPrivateRoute>,
                handle: {screen: 'line_wizard_entry'}
            },
            {
                path: "/lines/new/:step",
                element: <AgencyPrivateRoute><LineWizardScreen><LineWizardStep/></LineWizardScreen></AgencyPrivateRoute>,
                handle: {screen: 'line_wizard'}
            },
            {
                path: "/agency/profile",
                element: <AgencyPrivateRoute><AgencyProfile/></AgencyPrivateRoute>,
                handle: {screen: 'agency_profile'}
            },
            {
                path: "/agency/conections/export",
                element: <AgencyPrivateRoute><AgencyConnectionsExport/></AgencyPrivateRoute>,
                handle: {screen: 'agency_connections_export'}
            },
            {
                path: "/agency/conections",
                element: <AgencyPrivateRoute><AgencyConnectionsConfiguration/></AgencyPrivateRoute>,
                handle: {screen: 'agency_connections'}
            },
            {
                path: "/agency/connection",
                element: <Navigate to="/agency/conections" replace/>
            },
            {
                path: "/agency/connections",
                element: <Navigate to="/agency/conections" replace/>
            },
            {
                path: "/agency/personalization",
                element: <Navigate to="/agency/personalization/columns" replace/>
            },
            {
                path: "/agency/personalization/columns",
                element: <AgencyPrivateRoute><AgencyFlexIndicatorsConfiguration/></AgencyPrivateRoute>,
                handle: {screen: 'agency_personalization_columns'}
            },
            {
                path: "/agency/personalization/metrics",
                element: <AgencyPrivateRoute><CustomMetricsRouteGuard><CustomMetricsPage/></CustomMetricsRouteGuard></AgencyPrivateRoute>,
                handle: {screen: 'agency_personalization_metrics'}
            },
            {
                path: "/agency/flex-indicators",
                element: <Navigate to="/agency/personalization/columns" replace/>
            },
            {
                path: "/agency/custom-metrics",
                element: <Navigate to="/agency/personalization/metrics" replace/>
            },
            {
                path: "/agency/subscription",
                element: <AgencyPrivateRoute><AgencySubscription/></AgencyPrivateRoute>,
                handle: {screen: 'agency_subscription'}
            },
            {
                path: "/agency/ad-accounts",
                element: <AgencyPrivateRoute><AgencyAdAccountsAndStoresWrapper/></AgencyPrivateRoute>,
                handle: {screen: 'agency_ad_accounts'}
            },
            {
                path: "/agency-team",
                element: <AgencyPrivateRoute><AgencyTeam/></AgencyPrivateRoute>,
                handle: {screen: 'agency_team'}
            },
            {
                // Adopción del portal en todos los clientes. El gate es del backend (404 uniforme
                // si el plan no incluye el portal), no de la ruta.
                path: "/agency/portal-usage",
                element: <AgencyPrivateRoute><AgencyPortalUsage/></AgencyPrivateRoute>,
                handle: {screen: 'agency_portal_usage'}
            },
            {
                // Los prompts de la agencia (galería privada, plan 2026-09-25): `/agency/prompts` abre
                // la solapa propia y `/agency/prompts/dashbo` la de los sugeridos por Dashbo.
                path: "/agency/prompts/:tab?",
                element: <AgencyPrivateRoute><AgencyPromptsPage/></AgencyPrivateRoute>,
                handle: {screen: 'agency_prompts'}
            },
            // El Centro de Alertas (tanda 2026-10-06): sólo en la 2.1 y con el flag de la agencia; sin
            // eso la pantalla vuelve al inicio. Las rutas montan el MISMO elemento (otra `view`)
            // para que cambiar de solapa no remonte la pantalla. `/alerts` es «Ahora» (F3), la bandeja de
            // todos los clientes. Las páginas de detalle (UD-18: un aviso, una alerta, «Crear una alerta»)
            // son otra pantalla, `alerts_center_detail`: no tienen las solapas, que son el ancla fija del
            // recorrido del Centro, y si arrancaba ahí mostraba el modal y se quedaba sin pasos.
            {
                path: "/alerts",
                element: <AgencyPrivateRoute><AlertsCenterPage view="now"/></AgencyPrivateRoute>,
                handle: {screen: 'alerts_center'}
            },
            {
                path: "/alerts/rules",
                element: <AgencyPrivateRoute><AlertsCenterPage view="rules"/></AgencyPrivateRoute>,
                handle: {screen: 'alerts_center'}
            },
            {
                // «Avisos de las cuentas» (UD-18): fija, le gana a `/alerts/rules/:ruleId`.
                path: "/alerts/rules/cuentas",
                element: <AgencyPrivateRoute><AlertsCenterPage view="accounts"/></AgencyPrivateRoute>,
                handle: {screen: 'alerts_center_detail'}
            },
            {
                path: "/alerts/rules/:ruleId",
                element: <AgencyPrivateRoute><AlertsCenterPage view="edit"/></AgencyPrivateRoute>,
                handle: {screen: 'alerts_center_detail'}
            },
            {
                path: "/alerts/new",
                element: <AgencyPrivateRoute><AlertsCenterPage view="new"/></AgencyPrivateRoute>,
                handle: {screen: 'alerts_center_detail'}
            },
            {
                // «Inversión sin control»: la plata que ninguna línea mira (la solapa entre «Ahora» y
                // «Mis reglas»). Desde UD-5 (17/10) la abre TODA la 2.1, con o sin el Centro: sin él se ve
                // sola (`UncontrolledSoloPage`). Pantalla propia para medirla; para las guías es la misma
                // que el Centro SÓLO con el Centro (`guides/screens.js`).
                path: "/alerts/sin-control",
                element: <AgencyPrivateRoute><AlertsCenterPage view="uncontrolled"/></AgencyPrivateRoute>,
                handle: {screen: 'alerts_uncontrolled'}
            },
            {
                // «Aprende Dashbo» (tanda 2026-10-03-aprende-dashbo): la capacitación por persona que
                // reemplaza al drawer «Tus primeros pasos». Sólo en la 2.1: en el clásico la pantalla
                // redirige a `/agency/clients`.
                path: "/aprende",
                element: <AgencyPrivateRoute><LearnPage/></AgencyPrivateRoute>,
                handle: {screen: 'learn_dashbo'}
            },
            {
                // El túnel de alta vive en `/onboarding/*`. Esta ruta es de una implementación
                // anterior que quedó sin i18n ni estilos; se conserva como redirección para que
                // cualquier enlace guardado siga entrando al recorrido en vez de dar en la nada.
                path: "/agency/onboarding/:step?",
                element: <Navigate to="/onboarding" replace/>
            },
            {
                // AI Booster sin cliente elegido (card JCzWrSNo): el destino del grupo del sidebar
                // cuando no hay cliente en la URL. El gate lo resuelve la pantalla con los mismos
                // criterios que el sidebar, no la ruta.
                path: "/ia-booster",
                element: <AgencyPrivateRoute><AgencyIABooster/></AgencyPrivateRoute>,
                handle: {screen: 'agency_ia_booster'}
            },
            {
                path: "/sheets-sync",
                element: <AgencyPrivateRoute><SyncConfigurations/></AgencyPrivateRoute>,
                handle: {screen: 'sheets_sync'}
            },
            {
                path: "/connect-adwords-account",
                element: <AgencyPrivateRoute><ConnectAdwordsAccount/></AgencyPrivateRoute>,
                handle: {screen: 'connect_adwords'}
            },
            {
                path: "/connect-tiktok",
                element: <AgencyPrivateRoute><ConnectTiktok/></AgencyPrivateRoute>,
                handle: {screen: 'connect_tiktok'}
            },
            {
                path: "/connect-shopify",
                element: <ConnectShopify/>,
                handle: {screen: 'connect_shopify'}
            },
            {
                path: "/connect-shopify/success",
                element: <ShopifyMerchantSuccess/>,
                handle: {screen: 'connect_shopify_success'}
            },
            {
                path: "/connect-shopify/error",
                element: <ShopifyMerchantError/>,
                handle: {screen: 'connect_shopify_error'}
            },
            {
                path: "/connect-tienda-nube",
                element: <AgencyPrivateRoute><ConnectTiendaNube/></AgencyPrivateRoute>,
                handle: {screen: 'connect_tienda_nube'}
            },
            {
                path: "/connect-linkedin",
                element: <AgencyPrivateRoute><ConnectLinkedin/></AgencyPrivateRoute>,
                handle: {screen: 'connect_linkedin'}
            },
            {
                // La vuelta del OAuth de Escalafy, de la agencia (Economía o Conexiones) y del portal. Ruta
                // FIJA: es el `redirect_uri` registrado en Escalafy; de dónde vino viaja en sessionStorage.
                path: "/escalafy/callback",
                element: <AgencyOrPortalPrivateRoute><EscalafyCallback/></AgencyOrPortalPrivateRoute>,
                handle: {screen: 'connect_escalafy'}
            },
            {
                path: "/connect-ga4-account",
                element: <AgencyPrivateRoute><ConnectGA4Account/></AgencyPrivateRoute>,
                handle: {screen: 'connect_ga4'}
            },
            {
                path: "/connect-gsc-account",
                element: <AgencyPrivateRoute><ConnectGSCAccount/></AgencyPrivateRoute>,
                handle: {screen: 'connect_gsc'}
            },
            {
                path: "/connect-dv360-account",
                element: <AgencyPrivateRoute><ConnectDV360Account/></AgencyPrivateRoute>,
                handle: {screen: 'connect_dv360'}
            },
            {
                path: "/business-unit/:id/budget-history",
                element: <AgencyPrivateRoute><BusinessUnitBudgetHistory/></AgencyPrivateRoute>,
                handle: {screen: 'bu_budget_history'}
            },
            {
                path: "/business-unit/:id/accounts",
                element: <AgencyPrivateRoute><BusinessUnitAccounts/></AgencyPrivateRoute>,
                handle: {screen: 'bu_accounts'}
            },
            {
                path: "/business-unit/:id/alerts-configuration",
                element: <AgencyPrivateRoute><BusinessUnitAlertsConfiguration/></AgencyPrivateRoute>,
                handle: {screen: 'bu_alerts'}
            },
            {
                path: "/business-unit/:id/",
                element: <AgencyPrivateRoute><EditBusinessUnitPage/></AgencyPrivateRoute>,
                handle: {screen: 'bu_edit'}
            },
            {
                path: "/client/:id/crm-users",
                element: <AgencyPrivateRoute><ClientCRMUsers/></AgencyPrivateRoute>,
                handle: {screen: 'client_crm_users'}
            },
            {
                path: "/client/:id/dashbo-users",
                element: <AgencyPrivateRoute><ClientDashboUsers/></AgencyPrivateRoute>,
                handle: {screen: 'client_dashbo_users'}
            },
            {
                // Con ficha21 el wrapper redirige a /lines (card gtAL5axI, paso 8); sin él sirve
                // ClientMonitoring igual que hoy — en el clásico esa pantalla ES la de líneas.
                path: "/client/:id/business-units",
                element: <AgencyPrivateRoute><ClientMonitoringRoute/></AgencyPrivateRoute>,
                handle: {screen: 'client_monitoring'}
            },
            {
                path: "/client/:id/monitoring",
                element: <AgencyPrivateRoute><ClientMonitoringRoute/></AgencyPrivateRoute>,
                handle: {screen: 'client_monitoring'}
            },
            {
                // Todas las líneas como vista del Panel 2.1 (card gtAL5axI). Sin ficha21 el wrapper
                // redirige a /monitoring, que en el clásico ES la pantalla de líneas.
                path: "/client/:id/lines",
                element: <AgencyPrivateRoute><ClientLines/></AgencyPrivateRoute>,
                handle: {screen: 'client_lines'}
            },
            {
                // Las alertas vigentes del cliente (card j61xJLod): destino del tile del Panel. Sin
                // ficha21 el wrapper redirige a la Bitácora filtrada, que era el destino de antes.
                path: "/client/:id/alerts",
                element: <AgencyPrivateRoute><ClientAlerts/></AgencyPrivateRoute>,
                handle: {screen: 'client_alerts'}
            },
            {
                // La economía del negocio del cliente (card de la ficha 2.1 → «Editar»). Sin ficha21
                // o sin el módulo, el guard vuelve a la ficha.
                path: "/client/:id/economia",
                element: <AgencyPrivateRoute><ClientEconomia/></AgencyPrivateRoute>,
                handle: {screen: 'client_economics'}
            },
            {
                path: "/client/:id/history",
                element: <AgencyPrivateRoute><ClientBudgetHistory/></AgencyPrivateRoute>,
                handle: {screen: 'client_history'}
            },
            {
                path: "/client/:id/conections",
                element: <AgencyPrivateRoute><ClientConnections/></AgencyPrivateRoute>,
                handle: {screen: 'client_connections'}
            },
            {
                path: "/client/:id/connection",
                element: <RedirectToClientConnections/>
            },
            {
                path: "/client/:id/connections",
                element: <RedirectToClientConnections/>
            },
            {
                path: "/client/:id/activity-log",
                element: <AgencyPrivateRoute><ClientActivityLog/></AgencyPrivateRoute>,
                handle: {screen: 'client_activity_log'}
            },
            {
                // El Recorrido como una sola página (card LDdcpf52). Los actos son anclas, no
                // rutas: `/client/:id/booster#revisa`. Las rutas viejas de Memoria e IA redirigen
                // acá desde sus propios componentes, que ya esperan a que carguen los módulos.
                path: "/client/:id/booster",
                element: <AgencyPrivateRoute><ClientBoosterPage/></AgencyPrivateRoute>,
                handle: {screen: 'client_booster'}
            },
            {
                path: "/client/:id/memory",
                element: <AgencyPrivateRoute><ClientMemoryTab/></AgencyPrivateRoute>,
                handle: {screen: 'client_memory'}
            },
            {
                path: "/client/:id/memory/:view",
                element: <AgencyPrivateRoute><ClientMemoryTab/></AgencyPrivateRoute>,
                handle: {screen: 'client_memory'}
            },
            {
                path: "/client/:id/media-plan",
                element: <AgencyPrivateRoute><ClientMediaPlanTab/></AgencyPrivateRoute>,
                handle: {screen: 'client_media_plan'}
            },
            {
                path: "/client/:id/reports",
                element: <AgencyPrivateRoute><ClientReports/></AgencyPrivateRoute>,
                handle: {screen: 'client_reports'}
            },
            {
                // Informes como solapa de la ficha (2.1, card 7yIKxqZj). El MISMO elemento que
                // `/informes`: así pasar de una ruta a otra no remonta el editor. Sin ficha21 la
                // pantalla rebota sola a `/informes?client_id=`. Los `screen` son los de `/informes`:
                // de esos nombres dependen las guías y el seguimiento de pantallas.
                path: "/client/:id/informes",
                element: <AgencyPrivateRoute><InformesPage/></AgencyPrivateRoute>,
                handle: {screen: 'informes'}
            },
            {
                path: "/client/:id/informes/:informeId",
                element: <AgencyPrivateRoute><InformesPage/></AgencyPrivateRoute>,
                handle: {screen: 'informe_editor'}
            },
            {
                path: "/client/:id/agent/:sessionId?",
                element: <AgencyPrivateRoute><ClientAgent/></AgencyPrivateRoute>,
                handle: {screen: 'client_agent'}
            },
            {
                path: "/client/:id/ia-assistant",
                element: <AgencyPrivateRoute><ClientIAAssistant/></AgencyPrivateRoute>,
                handle: {screen: 'client_ia_assistant'}
            },
            {
                // Tab IA unificado (ficha v2): Dashbito + Conectar tu IA + Prompts. La ruta de
                // sesión de chat va explícita para poder deep-linkear una sesión de Dashbito.
                path: "/client/:id/ia/dashbito/:sessionId",
                element: <AgencyPrivateRoute><ClientIATab/></AgencyPrivateRoute>,
                handle: {screen: 'client_ia'}
            },
            {
                path: "/client/:id/ia/:view?",
                element: <AgencyPrivateRoute><ClientIATab/></AgencyPrivateRoute>,
                handle: {screen: 'client_ia'}
            },
            {
                path: "/client/:id/profile",
                element: <AgencyPrivateRoute><ClientProfile/></AgencyPrivateRoute>,
                handle: {screen: 'client_profile'}
            },
            {
                path: "/client/:id/portal-config",
                element: <AgencyPrivateRoute><ClientPortalTabPage/></AgencyPrivateRoute>,
                handle: {screen: 'client_portal_config'}
            },
            {
                path: "/client/:id/configuration",
                element: <AgencyPrivateRoute><ClientConfiguration/></AgencyPrivateRoute>,
                handle: {screen: 'client_configuration'}
            },
            {
                path: "/client/:client_id/app/:app_hash/",
                element: <AgencyPrivateRoute><ClientAppContent/></AgencyPrivateRoute>,
                handle: {screen: 'client_app_content'}
            },
            {
                path: "/client/:id/control-central",
                element: <AgencyPrivateRoute><ClientControlCentral/></AgencyPrivateRoute>,
                handle: {screen: 'client_control_central'}
            },
            {
                path: "/client/:id/preview",
                element: <AgencyPrivateRoute><ClientPortalPreview/></AgencyPrivateRoute>,
                handle: {screen: 'client_portal_preview'}
            },
            {
                path: "/client/:id/preview/dashbo-connect",
                element: <RedirectToClientPreviewMCP/>
            },
            {
                path: "/client/:id/preview/dashbo-mcp",
                element: <AgencyPrivateRoute><ClientPortalPreview/></AgencyPrivateRoute>,
                handle: {screen: 'client_portal_preview'}
            },
            {
                path: "/client/:id/preview/reports",
                element: <AgencyPrivateRoute><ClientPortalPreview/></AgencyPrivateRoute>,
                handle: {screen: 'client_portal_preview'}
            },
            {
                path: "/client/:id",
                element: <AgencyPrivateRoute><ClientDefaultRoute/></AgencyPrivateRoute>,
                handle: {screen: 'client_default'}
            },
            {
                path: "/clients",
                element: <AgencyPrivateRoute><UserClients/></AgencyPrivateRoute>,
                handle: {screen: 'user_clients'}
            },
            {
                path: "/agency/clients",
                element: <AgencyPrivateRoute><AgencyClients/></AgencyPrivateRoute>,
                handle: {screen: 'agency_clients'}
            },
            {
                path: "/user-configuration",
                element: <AgencyPrivateRoute><UserConfiguration/></AgencyPrivateRoute>,
                handle: {screen: 'user_configuration'}
            },
            {
                path: "/user/:id/profile",
                element: <AgencyPrivateRoute><UserProfile/></AgencyPrivateRoute>,
                handle: {screen: 'user_profile'}
            },
            {
                path: "/user/:id/security",
                element: <AgencyPrivateRoute><UserSecurity/></AgencyPrivateRoute>,
                handle: {screen: 'user_security'}
            },
            {
                path: "/user/:id/module/marketing",
                element: <AgencyPrivateRoute><UserModuleMarketing/></AgencyPrivateRoute>,
                handle: {screen: 'user_module_marketing'}
            },
            {
                path: "/user/:id/module/manage-accounts",
                element: <AgencyPrivateRoute><UserModuleManageAccounts/></AgencyPrivateRoute>,
                handle: {screen: 'user_module_manage_accounts'}
            },
            {
                path: "/user/:id",
                element: <AgencyPrivateRoute><UserAlerts/></AgencyPrivateRoute>,
                handle: {screen: 'user_alerts'}
            },
            // Portal de Cliente
            {
                path: "/portal",
                element: <PortalPrivateRoute><PortalHome/></PortalPrivateRoute>,
                handle: {screen: 'portal_home'}
            },
            {
                path: "/portal/connections",
                element: <PortalPrivateRoute><PortalConnections/></PortalPrivateRoute>,
                handle: {screen: 'portal_connections'}
            },
            {
                path: "/portal/memory",
                element: <PortalPrivateRoute><PortalMemory/></PortalPrivateRoute>,
                handle: {screen: 'portal_memory'}
            },
            {
                path: "/portal/dashbo-connect",
                element: <Navigate to="/portal/dashbo-mcp" replace/>
            },
            {
                path: "/portal/dashbo-mcp",
                element: <PortalPrivateRoute><PortalDashboMCP/></PortalPrivateRoute>,
                handle: {screen: 'portal_dashbo_mcp'}
            },
            {
                path: "/portal/reports",
                element: <PortalPrivateRoute><PortalReportsLanding/></PortalPrivateRoute>,
                handle: {screen: 'portal_reports'}
            },
            {
                path: "/crm/login",
                element: <LoginCrm/>
            },
            {
                path: "/crm/lead/:id",
                element: <CRMPrivateRoute><LeadDetail/></CRMPrivateRoute>,
                handle: {screen: 'crm_lead'}
            },
            {
                path: "/crm/config",
                element: <CRMPrivateRoute><ConfigPage/></CRMPrivateRoute>,
                handle: {screen: 'crm_config'}
            },
            {
                path: "/crm/:clientId/lead/:id",
                element: <AgencyPrivateRoute><LeadDetail/></AgencyPrivateRoute>,
                handle: {screen: 'crm_lead'}
            },
            {
                path: "/crm/:clientId/config",
                element: <AgencyPrivateRoute><ConfigPage/></AgencyPrivateRoute>,
                handle: {screen: 'crm_config'}
            },
            {
                path: "/crm/:clientId",
                element: <AgencyPrivateRoute><LeadsPage/></AgencyPrivateRoute>,
                handle: {screen: 'crm_leads'}
            },
            {
                path: "/crm",
                element: <CRMPrivateRoute><LeadsPage/></CRMPrivateRoute>,
                handle: {screen: 'crm_leads'}
            },
            {
                path: "/manage-accounts",
                element: <AgencyPrivateRoute><AdAccountList/></AgencyPrivateRoute>,
                handle: {screen: 'manage_accounts'}
            },
            {
                path: "/page-not-found",
                element: <PageNotFound/>
            },
            {
                path: "/r/:uuid",
                element: <ReportViewer/>
            },
            {
                path: "*",
                element: <PageNotFound/>
            }
];

// Las páginas que ve el vendedor de Mercado Libre (la del link es de `ma-link-frontend`): las abre desde
// WhatsApp, en el celular, alguien que nunca vio Dashbo. Van FUERA de `<App/>` —sin el marco ni los
// providers que piden datos de una sesión— y la del link en su propio chunk, para que una conexión lenta
// no baje la aplicación entera.
const PublicConnectPage = lazy(() => import("./components/connection_links/PublicConnectPage"));

export const publicRoutes = [
    {
        // La vuelta del OAuth de Mercado Libre: la ÚNICA redirect registrada en la app. Va SIN
        // `AgencyPrivateRoute` y FUERA de `<App/>` porque la usan la agencia, el cliente desde su Portal y el
        // vendedor con el link: el vendedor ve su resultado sin los avisos ni la burbuja de una sesión que
        // pueda estar abierta en ese navegador, y para la agencia y el Portal es una pantalla de carga de un
        // instante (sus toasts los muestra la pantalla de destino: react-toastify los encola hasta que monta
        // un contenedor). El componente decide por el prefijo del `state` (contrato §6.2).
        path: "/connect-mercado-ads-account",
        element: <ConnectMercadoAdsAccount/>,
        errorElement: <RouterErrorPage/>
    },
    {
        path: "/conectar/:token",
        element: (
            <Suspense fallback={<div className="box-loader"><Spinner color="positive"/></div>}>
                <PublicConnectPage/>
            </Suspense>
        ),
        errorElement: <RouterErrorPage/>
    }
];

export const router = createBrowserRouter([
    ...publicRoutes,
    {
        element: <App/>,
        errorElement: <RouterErrorPage/>,
        children: routeChildren
    }
]);
